// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o2-0";
export var animationContainer = "_o2-1";
export var itemPrice = "_o2-a";
export var itemizedContent = "_o2-9";
export var itemizedHeader = "_o2-7";
export var itemizedRow = "_o2-8";
export var itemizedSection = "_o2-6";
export var modalContent = "_o2-2";
export var orderName = "_o2-3";
export var refundOption = "_o2-4";
export var refundOptionsContainer = "_o2-5";
export var shippingLabel = "_o2-b";
export var totalRow = "_o2-c";